import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryTransactionStatsArgs, TransactionStats } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryTransactionStatsArgs;
type TData = Array<TransactionStats>;

const MOCK: TVariables = {
  createdAtAfter: undefined,
  createdAtBefore: undefined,
  invoiceId: undefined,
  poCode: undefined,
  quality: undefined,
  query: undefined,
  sortAttribute: undefined,
  sortOrder: undefined,
  sourceLanguageCode: undefined,
  targetLanguageCode: undefined,
  transactionType: undefined,
  userId: undefined
};

export const useTransactionStats = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query transactionStats(
      $userId: ID
      $invoiceId: ID
      $transactionType: TransactionTypeEnum
      $quality: QualityEnum
      $query: String
      $sourceLanguageCode: String
      $targetLanguageCode: String
      $createdAtAfter: ISO8601DateTime
      $createdAtBefore: ISO8601DateTime
      $sortAttribute: TransactionSortAttributeEnum
      $sortOrder: SortOrderEnum
    ) {
      transactionStats(
        userId: $userId
        invoiceId: $invoiceId
        transactionType: $transactionType
        quality: $quality
        query: $query
        sourceLanguageCode: $sourceLanguageCode
        targetLanguageCode: $targetLanguageCode
        createdAtAfter: $createdAtAfter
        createdAtBefore: $createdAtBefore
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
      ) {
        balance
        currency
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['transactionStats', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
